<template>
  <div class="cp-backoffice-sidebar has-background-light">
     <div class="cp-backoffice-sidebar-title-item has-background-grey">
      <b-icon
        class="cp-backoffice-sidebar-title-item-icon has-text-white"
        pack="fas"
        icon="sliders-h"
      ></b-icon>
      <p class="cp-backoffice-sidebar-title-item-text has-text-white">
        {{ $t('backoffice.sidebar.title') }}
      </p>
    </div>
    <b-menu class="is-custom-mobile ">
       <b-menu-list label="">
          <b-menu-item icon="shopping-cart" icon-pack="fas">
             <template slot="label" slot-scope="props">
                Adjust Products
              <b-icon pack="fas" class="is-pulled-right"
              :icon="props.expanded ? 'menu-down' : 'menu-up'"></b-icon>
            </template>
             <b-menu-item
              tag="router-link"
              target="_self"
              to="/backoffice/products"
              icon-pack="fas"
              icon="account" label="All Products ">
             </b-menu-item>
             <b-menu-item
                tag="router-link"
                target="_self"
                to="/backoffice/products/new"
                icon="account" label="Add Products">
             </b-menu-item>
          </b-menu-item>
          <b-menu-item icon="file-alt" icon-pack="fas" label="Adjust Orders">
              <b-menu-item
              tag="router-link"
              target="_blank"
              :to="{path: '/allorder'}"
              href="https://docs.google.com/spreadsheets/d/1ZcVDnPk_Kl15qcnOZfLV-54u0GQ-nwHXzBwY60g87rQ/edit?usp=sharing"
              icon="account" label="All order ">
             </b-menu-item>
          </b-menu-item>
        </b-menu-list>
        <b-menu-list label="">
          <b-menu-item icon="edit" icon-pack="fas" label="Blog">
             <b-menu-item
              tag="router-link"
              target="_self"
              to="/backoffice/articles"
              icon="account" label="All Content">
             </b-menu-item>
             <b-menu-item
                tag="router-link"
                target="_self"
                to="/backoffice/articles/new"
                icon="account" label="Add Content">
             </b-menu-item>
          </b-menu-item>
        </b-menu-list>
      <b-menu-list>
          <b-menu-item
                tag="router-link"
                target="_self"
                to="/backoffice/contact"
                icon="envelope"
                label="Contact us"
                icon-pack="fas"
                >
             </b-menu-item>
      </b-menu-list>
    </b-menu>
  </div>
</template>

<script>
// import SidebarItem from '@/components/backoffice/SidebarItemLink.vue';

export default {
  name: 'Sidebar',
  components: {
    // SidebarItem,
  },
};
</script>

<style lang="scss" scoped>

.menu-list a{
    padding-top: 20px !important;
    padding-bottom: 20px !important;
    // display: flex;
    align-items: center;
}
.cp-backoffice-sidebar {
  width: 300px;
  min-width: 300px;
  min-height: 100%;

  &-title-item {
    padding-left: 15px;
    padding-right: 15px;
    padding-top: 10px;
    padding-bottom: 10px;
    display: flex;
    align-items: center;
  }
  &-title-item-text {
    margin-left: 10px;
  }
}
</style>
